// extracted by mini-css-extract-plugin
export default {"input":"_2ealv"};